export default __webpack_public_path__ + "static/media/comm 1.18783a36.jpg";